import { type GetBalanceCurrencyDTO } from '@capsicum/common';

/**
 * This is a temporary util.
 * Currently ncwBalance.currencies is a Object, but the data contract says it should be a Array;
 * awaiting BE to fix currencies data type.
 * @param {unknown} data The ncwBalance.currencies from the NCW Balance API endpoint payload
 * @returns {Array<GetBalanceCurrencyDTO>} result a Array of GetBalanceCurrencyDTO type.
 */
export const convertNcwBalanceCurrencies = (data?: unknown): Array<GetBalanceCurrencyDTO> => {
	let result: Array<GetBalanceCurrencyDTO> = [];

	if (!data || data === null) {
		result = [];
	} else if (Array.isArray(data)) {
		result = data;
	} else if (typeof data === 'object') {
		result = Object.values(data);
	} else {
		result = [];
	}

	return result;
};
